// src/components/pages/watch/WatchPage.js

import React from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Grid,
} from "@mui/material";
import { NAVBAR_HEIGHT } from "../../../constants/constants";
import { useNavigate } from "react-router-dom";

// Placeholder data for the "main video" at the top
const TOP_VIDEO = {
  id: 999,
  title: "Bjorn's Colorado Honey",
  description:
    "Meet the family behind Bjorn’s Colorado Honey and learn why we are different from other honey companies. Enjoy!",
  image:
    "https://images.unsplash.com/photo-1693534964210-3ec851c095e2?q=80&w=3550&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // 16:9 ratio
};

// Placeholder data for 5 series
const SERIES_LIST = [
  {
    id: 1,
    title: "Late Night Chat",
    description: "Join us for late-night fun with special guests.",
    image:
      "https://images.unsplash.com/photo-1554780632-511142996491?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 2,
    title: "Denver Zoo Sundays",
    description: "Weekly highlights from the Denver Zoo.",
    image:
      "https://images.unsplash.com/photo-1718435126504-1de9f5b5c17e?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 3,
    title: "Mountain Adventures",
    description: "Explore breathtaking mountain landscapes.",
    image:
      "https://plus.unsplash.com/premium_photo-1670985849617-ce4853d4a533?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 4,
    title: "Culinary Journeys",
    description: "Travel the world through unique dishes.",
    image:
      "https://plus.unsplash.com/premium_photo-1671580679044-3558d358d112?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 5,
    title: "Urban Explorers",
    description: "Dive into cityscapes, architecture, and nightlife.",
    image:
      "https://images.unsplash.com/photo-1524373079361-ff1452de1d84?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

const WatchPage = () => {
  const navigate = useNavigate();

  // Handle click on a series card
  const handleSeriesClick = (seriesId) => {
    navigate(`/series/${seriesId}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
        bgcolor: "#f9f9f9",
      }}
    >
      {/* Top video as a card with 16:9 aspect ratio */}
      <Box
        sx={{ px: 2, pb: 4, mt: 3, width: "95%", maxWidth: 800, mx: "auto" }}
      >
        <Card
          onClick={() => handleSeriesClick(TOP_VIDEO.id)}
          elevation={0}
          sx={{
            cursor: "pointer",
            borderRadius: 1,
            backgroundColor: "transparent",
          }}
        >
          <CardMedia
            component="img"
            image={TOP_VIDEO.image}
            alt={TOP_VIDEO.title}
            sx={{
              width: "100%",
              aspectRatio: "16/9",
              objectFit: "cover",
              borderRadius: 1,
            }}
          />
          <CardContent>
            <Typography variant="subtitle1" fontWeight="bold">
              {TOP_VIDEO.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {TOP_VIDEO.description}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Series list (responsive grid) */}
      <Box
        sx={{
          px: 2,
          pb: 4,
          pt: 1,
          width: "95%",
          maxWidth: 800,
          mx: "auto",
          backgroundColor: "white",
        }}
      >
        <Typography variant="h6" sx={{ mb: 1 }}>
          More Series
        </Typography>
        <Grid container spacing={2}>
          {SERIES_LIST.map((series) => (
            <Grid item xs={6} sm={6} md={4} lg={3} key={series.id}>
              <Card
                onClick={() => handleSeriesClick(series.id)}
                elevation={0}
                sx={{
                  cursor: "pointer",
                  borderRadius: 1,
                  backgroundColor: "transparent",
                }}
              >
                <CardMedia
                  component="img"
                  image={series.image}
                  alt={series.title}
                  sx={{
                    width: "100%",
                    aspectRatio: "16/9",
                    objectFit: "cover",
                    borderRadius: 1,
                  }}
                />
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {series.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {series.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WatchPage;
